import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const ANY_ROLE = '*';

const router = new Router({
	mode: 'history',
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return {x: 0, y: 0};
		}
	},
	routes: [
		{
			path: '/',
			component: require('../components/Home')
		},
		{
			path: '/change-password/:uuid',
			component: require('../components/ChangePassword'),
			props: true
		},
		{
			path: '*',
			component: require('../components/Error')
		}
	]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js